declare global {
  interface Window {
    tomi: any;
  }
}

const tomiAI = {
  getGaId: () => {
    const { ga } = window as any;
    if (typeof ga !== 'undefined' && ga.getAll().length > 0) return ga.getAll()[0].get('clientId');
  },
  postPixel: (category: string) => {
    window.tomi = window.tomi || [];
    window.tomi.push({
      pid: category,
      ppr: ''
    });
  }
};

export default tomiAI;
